import React, { useState, useEffect } from "react"
import { Flex, Box } from "@rebass/grid/emotion"
import { navigate } from "gatsby-link"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { ButtonNova } from "@nutrafol/nutrafol-ui-kit/dist/ButtonNova"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"

import AccordionItem from "../../accordionitem/accordionitem"

import { AccordionWrapper, AccordionFlex } from "./accordion.styled"

const Accordion = ({ data }) => {
  const [openItem, setOpenItem] = useState(null)
  const {
    heading = `We’re serious about facts. <br class="ask-br"/>Ask away.`,
    accordions = [],
    includeLinkToFaqPage = true,
  } = data

  const handleClick = () => {
    segmentEvent("Marketing CTA Clicked", {
      destination: "/faq/",
      module_location: "bottom_fold",
      text: "See all FAQs",
      type: "link",
    })
    navigate("/faq/")
  }

  const handleToggle = (i, event, item) => {
    event.preventDefault()
    const isOpen = openItem === i
    setOpenItem(isOpen ? null : i)
    const eventName = isOpen ? "Section Collapsed" : "Section Expanded"
    segmentEvent(eventName, {
      module_name: "FAQs",
      section: item.title,
    })
  }

  useEffect(() => {
    const quizLink = document.querySelectorAll(".accordion .quiz")
    quizLink.forEach((link) => {
      link.addEventListener("click", (e) => {
        segmentEvent("Marketing CTA Clicked", {
          destination: e?.target?.getAttribute("href"),
          text: e?.target?.innerText,
          type: "link",
        })
      })
    })
  })

  return (
    <AccordionFlex flexwrap="wrap" className="accordion">
      <Box width={1}>
        <TextElementNova
          text={heading}
          element="h2"
          className={`Title-20-Super-Normal ${
            data.includeLinkToFaqPage ? "mb-6 sm:mb-10" : "mb-10"
          }`}
        />
        {includeLinkToFaqPage ? (
          <ButtonNova
            label={"See All FAQs"}
            icon={"Left"}
            level={"Tertiary"}
            onClick={handleClick}
            className="mb-10 ml-0"
          />
        ) : null}
        <AccordionWrapper>
          {accordions.map((item, i) => (
            <AccordionItem
              item={item}
              index={i}
              openItem={openItem}
              handleToggle={(i, event, item) => handleToggle(i, event, item)}
              key={i}
            />
          ))}
        </AccordionWrapper>
      </Box>
    </AccordionFlex>
  )
}
export default Accordion
